import React from "react";

export default function Dashboard() {
    return (
    <main>
         <div className="row">
             <div className="col-12 justify-content-center aligns-items-center">
                 <p>Welcome to Social Tag Management</p>
             </div>
         </div>
    </main>
    );
} 